module.exports = __webpack_public_path__ + "img/8d6131a.jpg";